module.exports = __webpack_public_path__ + "static/media/ils-no-data.36d442b9.svg";